import axios from '../utils/axios'
import { createAction } from 'redux-actions'
import { formatCurrency } from '../utils'
import config from '../config'

const serverUrl = config.apiGateway.URL

export const fetchProjects = createAction(`FETCH_PROJECTS`, (q) => {
    return axios.get(`${serverUrl}projects`, {
        params: { q }
    })
        .then(response => response.data)
        .then(projects => ({ projects }))
})

export const fetchLanguages = createAction(`FETCH_LANGUAGES`, () => {
    return axios.get(`${serverUrl}languages`)
        .then(response => response.data)
        .then(languages => ({ languages }))
})

export const updateLanguage = createAction('UPDATE_LANGUAGE', (data) => {
    return axios.put(`${serverUrl}languages/${data.id}`, {data})
        .then(response => response.data)
        .then(language => ({ language }))
})

export const createNewLanguage = createAction('CREATE_NEW_LANGUAGE', (data) => {
    return axios.put(`${serverUrl}languages`, {data})
        .then(response => response.data)
        .then(language => ({ language }))
})

export const removeLanguage = createAction('REMOVE_LANGUAGE', (language) => {
    return axios.delete(`${serverUrl}languages/${language.id}`)
        .then((result) => {
            if (result instanceof Error) {
                return Promise.resolve(null)
            }
            return Promise.resolve({ language })
        })
})

export const fetchUsers = createAction(`FETCH_USERS`, () => {
    return axios.get(`${serverUrl}users`)
        .then(response => response.data)
        .then(users => ({ users }))
})

export const updateUser = createAction('UPDATE_USER', (data) => {
    return axios.put(`${serverUrl}users/${data.id}`, {data})
        .then(response => response.data)
        .then(user => ({ user }))
})

export const createNewUser = createAction('CREATE_NEW_USER', (data) => {
    return axios.put(`${serverUrl}users`, {data})
        .then(response => response.data)
        .then(user => ({ user }))
})

export const removeUser = createAction('REMOVE_USER', (user) => {
    return axios.delete(`${serverUrl}users/${user.id}`)
        .then((result) => {
            if (result instanceof Error) {
                return Promise.resolve(null)
            }
            return Promise.resolve({ user })
        })
})

export const fetchProject = createAction(`FETCH_PROJECT`, (id) => {
    return axios.get(`${serverUrl}projects/${id}`)
        .then(response => response.data)
        .then(project => ({ project }))
})

export const fetchProjectSuppliers = createAction(`FETCH_PROJECT_SUPPLIERS`, (projectId) => {
    return axios.get(`${serverUrl}projectSuppliers?projectId=${projectId}`)
        .then(response => response.data.map(row => ({
            ...row,
            supplierCost: formatCurrency(row.supplierCost)
        })))
        .then(projectSuppliers => ({ projectSuppliers }))
})

export const setSearchTerm = createAction(`SET_SEARCH_TERM`, (searchTerm) => {
    return { searchTerm }
})

export const updateProject = createAction(`UPDATE_PROJECT`, ({ project, projectSuppliers }) => {
    return axios.put(`${serverUrl}projects/${project.id}`, { project, projectSuppliers })
        .then(response => response.data)
        .then(([project, projectSuppliers]) => ({
            project, projectSuppliers: projectSuppliers.map(row => ({
                ...row,
                supplierCost: formatCurrency(row.supplierCost)
            }))
        }))
})

export const createNewProject = createAction(`CREATE_NEW_PROJECT`, ({ businessArea, mainCategory, prospectNumber }) => {
    return axios.put(`${serverUrl}projects`, { businessArea, mainCategory, prospectNumber })
        .then(response => response.data)
        .then(({ newId }) => ({ newId }))
})

export const createNewEdition = createAction(`CREATE_NEW_EDITION`, ({ projectId, data }) => {
    return axios.post(`${serverUrl}projects/${projectId}`, { data })
        .then(response => response.data)
        .then((project) => ({ project }))
})

export const validateToken = createAction(`VALIDATE_TOKEN`, (code) => {
    return axios.post(`${serverUrl}checkCode`, { code })
        .then(response => response.data)
        .then(({ user, token }) => ({ user, token }))
        .catch(() => ({ user: false, token: undefined }))
})

export const loginUser = createAction(`LOGIN_USER`, (samlCookie) => {
    return axios.post(`${serverUrl}auth`, { samlCookie })
        .then(response => response.data)
        .then(({ user, token }) => ({ user, token }))
        .catch(() => ({ user: false, token: undefined }))
})



// WEBPACK FOOTER //
// ./src/store/actions.js